




















































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import SkillsLogos from "@/components/SkillsLogos.vue";

@Component({
  components: {
    SkillsLogos,
  },
})
export default class Home extends Vue {
  goToServices() {
    this.$router.push("/services/sw-development");
  }

  goToExperiences() {
    this.$router.push("/our-work/experiences");
  }

  goToSkills() {
    this.$router.push("/our-work/skills");
  }
}
